import React from "react";
import q1 from "../../assets/images/q1.jpg";

function AddGratitude(props) {
  return <h1>Add Gratitude</h1>;
}

export default AddGratitude;
